<template>
  <div class="container">
    <NLSLogo />
		<router-view />
	</div>
</template>
<script>
	import { defineAsyncComponent } from "vue";
	import "@/assets/css/layout.css";
	import "@/assets/css/contents.css";

	const NLSLogo = defineAsyncComponent(() =>
		import("@/tenants/NLS/components/molecules/NLSLogo.vue")
	);
	export default {
		components: {
			NLSLogo,
		},
	}
</script>
<style>
</style>